import axios from "axios";
import { API_URL } from "../appConstants";

export function useHttp({ config, headers } = {}) {
  const headerConfig = {
    Accept: "application/json",
    // "Content-Type": "application/json, multipart/form-data",
    ...headers,
  };

  const axiosInstance = axios.create({
    headers: headerConfig,
    baseURL: API_URL,
    timeout: 30 * 1000,
    ...config,
  });

  axiosInstance.interceptors.request.use((requestConfig) => {
    const latestToken = localStorage.getItem("token");

    if (!requestConfig.headers) {
      requestConfig.headers = {};
    }

    if (latestToken) {
      requestConfig.headers.Authorization = `Bearer ${latestToken}`;
    } else {
      delete requestConfig.headers.Authorization;
    }

    return requestConfig;
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      const data = response?.data;
      if (typeof data === "string" && (data.includes("doctype html") || data.includes("<!"))) {
        throw new Error("Service unavailable, please contact support");
      }

      return response;
    },
    (error) => {
      console.log("error", error)
      const DATA = error?.response?.data; //these are coming from API response
      const MESSAGE = DATA?.MESSAGE || "An error occurred";
      const STATUS = DATA?.STATUS || "Unknown";

      if (error?.response?.status === 401 || error?.response?.status === 403) {
        console.log(error)
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            const event = new CustomEvent('userDeactivated', {
              detail: { message: MESSAGE}
            });
            window.dispatchEvent(event);
          }, 100);
        }
      }

      // Create a custom Error object
      let customError = new Error(MESSAGE);
      customError.status = STATUS;
      customError.originalError = error; // Attach original error if needed

      return Promise.reject(customError);
    }
  );

  return axiosInstance;
}
